// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3QtHSOZArOpazScfQSbS4L"};